package amazon.lastmile.inject

import app.nestbridge.feature.invitations.ui.InvitationOtpVerificationUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationOtpVerificationUiFactory::class)
public interface AppNestbridgeFeatureInvitationsUiInvitationOtpVerificationUiFactory {
  @Provides
  @IntoSet
  public fun provideInvitationOtpVerificationUiFactoryFactoryMultibinding(invitationOtpVerificationUiFactory: InvitationOtpVerificationUiFactory): Ui.Factory = invitationOtpVerificationUiFactory
}
